/* eslint-disable */
import Vue from 'vue'
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import {
  mapGetters
} from 'vuex';
export default {
  name: 'lymphomap-form',
  components: {
    DatePicker
  },
  props: [],
  data () {
    return {
      file:null,
      name: '',
      uploadFileName: '',
      features:'',
      uploadingLoader:false,
      submitted:false,
      filetype:'ANN',
      resultData:'',
      errMsgShow:false,
      errMsg:'',
      task:'Prognosis of Diffuse Large B Cell Lymphoma',
      taskEditAble:true,
      attribute: {
        forecast_key:'',
        forecast_val: '',
        forecast_label: ''
      },
      attributes: [{
        forecast_key:'x1',
        forecast_val: '1',
        forecast_label: 'High Proliferation Index'
      },{
        forecast_key:'x2',
        forecast_val: '0',
        forecast_label: 'LDH Less Than Upper Limit of Normal'
      },{
        forecast_key:'x3',
        forecast_val: '1',
        forecast_label: 'Bcl or MyC Expression'
      },{
        forecast_key:'x4',
        forecast_val: '1',
        forecast_label: 'Cell of Origin is GCB'
      },{
        forecast_key:'x5',
        forecast_val: '0',
        forecast_label: 'Bcl and MyC Relocation'
      }],
      my_features_data :[],
      my_feature_label:{},
      response_data:'',
      first_name:'',
      last_name:'',
      patient_name:'', 
      patient_age:'', 
      patient_gender:'',
      patient_id:'',
      patient_date:'',
      inputAttrList:[],
      local_Array: {
        forecast_val: '',
        key:'',
        value: ''
      },
      algorithm_loader:false
    }
  },
  computed: {
    ...mapGetters([
      'getInputAttrListGetters'
    ]),
    getInputAttrListedFun() {
      this.inputAttrList = this.$store.getters.getInputAttrListGetters.data
      if(this.inputAttrList && this.inputAttrList.length >= 1){
        this.features = this.inputAttrList.length
      }else{
        this.features = this.attributes.length
      }
      return
    },
  },
  beforeMount(){
    this.getInputAttrListedFun
  },
  mounted () {
    this.getInputAttrListedFun
    setTimeout(function() {
      $('input').attr('autocomplete', 'off');
  }, 100);
  },
  methods: {
    resetFieldFun(){
      this.uploadFileName = '';
      this.patient_name = '';
      this.first_name = '';
      this.last_name = '';
      this.patient_age = '';
      this.patient_gender = '';
      this.patient_id = '';
      this.patient_date = '';
      for(var i = 0; i < this.attributes.length; i++){
        this.attributes[i].forecast_val = ''
      }
      this.$validator.reset();
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.filesSize = this.$refs.file.files[0].size;
        this.name = this.files.name;
        this.uploadFileName = this.files.name
      }  else {
        this.uploadFileName = '';
      }
    },
    validateFileBeforeSubmit(e) {
      $(window).scrollTop(0);
      this.my_features_data = [],
      this.my_feature_label = {}
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.algorithm_loader = true
          this.submitted = true;
          this.resultData = ''
          this.uploadingLoader = true
          this.errMsgShow = false
          this.errMsg = ''
          let formData = new FormData();
          formData.append('name', this.task);
          formData.append('patient_name', this.first_name + ' ' + this.last_name);
          formData.append('patient_age', this.patient_age);
          formData.append('patient_gender', this.patient_gender);
          formData.append('patient_id', this.patient_id);
          formData.append('patient_date', this.patient_date);
          if(this.filetype == 'ANN'){
            formData.append('algorithm_name', 'Deep Learning');
          }else if(this.filetype == 'KNN'){
            formData.append('algorithm_name', 'k Nearest Neighbor');
          }else if(this.filetype == 'PSM'){
            formData.append('algorithm_name', 'kNN with PSM');
          }else if(this.filetype == 'SVM'){
            formData.append('algorithm_name', 'Support Vector Machine');
          }else if(this.filetype == 'NB'){
            formData.append('algorithm_name', 'Naive Bayes');
          }else if(this.filetype == 'RF'){
            formData.append('algorithm_name', 'Random Forest');
          }else if(this.filetype == 'DTREE'){
            formData.append('algorithm_name', 'Decision Tree');
          }
          formData.append('data_file', this.file);
          formData.append('no_of_features', this.features);
          if(this.inputAttrList.length >= 1){
            for(var i = 0; i < this.inputAttrList.length; i++){
                this.my_features_data.push([this.inputAttrList[i].forecast_val])
            }
          }else{
            for(var i = 0; i < this.attributes.length; i++){
              this.my_features_data.push([this.attributes[i].forecast_val])
            }
          }
          formData.append('features', this.my_features_data);
          if(this.inputAttrList.length >= 1){
          Object.keys(this.inputAttrList).map((index) => {
            this.my_feature_label['x' + (parseInt(index) + 1) ] = this.inputAttrList[index].value
          });}else{
          Object.keys(this.attributes).map((index) => {
            this.my_feature_label['x' + (parseInt(index) + 1) ] = this.attributes[index].forecast_label
          });}
          formData.append('input_attributes', JSON.stringify(this.my_feature_label));
            if(this.filetype == 'KNN'){
              this.$store.dispatch('createKnnDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            } if(this.filetype == 'PSM'){
              this.$store.dispatch('createKnnPsmDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            }else if(this.filetype == 'ANN'){
              this.$store.dispatch('createAnnDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            }else if(this.filetype == 'SVM'){
              this.$store.dispatch('createSvmDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            }else if(this.filetype == 'NB'){
              this.$store.dispatch('createNbDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            }else if(this.filetype == 'RF'){
              this.$store.dispatch('createRandomForestDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            }else if(this.filetype == 'DTREE'){
              this.$store.dispatch('createDecisionTreeDataFun', formData)
              .then((res) => {
                if (res.status == '200') {
                  setTimeout(()=>{
                    this.algorithm_loader = false
                    this.resultData = res.data
                    this.uploadingLoader = false
                  },8000)
                }
              })
              .catch((err) => {
                setTimeout(()=>{
                this.errMsgShow = true
                this.errMsg = err.data
                this.uploadingLoader = false
                this.algorithm_loader = false
              },8000)
              })
            }
          return
        }
      });
    },
    updateTask() {
      this.taskEditAble = false
    },
    updatedTask() {
      this.taskEditAble = true
    },
    addNewAttributes : function () {
      this.attributes.push(Vue.util.extend({}, this.attribute))
      this.features = this.attributes.length
    },
    addApiNewAttributes: function () {
      this.inputAttrList.push(Vue.util.extend({}, this.local_Array))
      this.features = this.inputAttrList.length
    },
    removeApiAttributes : function (index) {
      Vue.delete(this.inputAttrList, index);
      this.features = this.inputAttrList.length
    },
    removeAttributes : function (index) {
      Vue.delete(this.attributes, index);
      this.features = this.attributes.length
    },
    updateAttributes(index){
      $('.updateAttributes' + index).addClass('d-none')
      $('.updatedAttributes' + index).removeClass('d-none')
    },
    updatedAttributes(index){
      $('.updateAttributes' + index).removeClass('d-none')
      $('.updatedAttributes' + index).addClass('d-none')
    }
  },
  watch:{
    getInputAttrListedFun() {
      this.inputAttrList = this.$store.getters.getInputAttrListGetters.data
      if(this.inputAttrList && this.inputAttrList.length >= 1){
        this.features = this.inputAttrList.length
      }else{
        this.features = this.attributes.length
      }
      return
    },
  }
}